import { AppLocation } from 'src/navigation/appLocations'
import { reportingPinnedUrl, reportingUrl } from 'src/navigation/urls'

export interface ReportingRouteNode {
  /** Stable key used by the Reporting page's route mirror. */
  readonly key: 'pinned' | 'root'
  /** Exact URL pattern for a Reporting page. */
  readonly path: string
  /** AppLocation used by the global shell metadata resolver. */
  readonly appLocation: AppLocation
}

export interface ReportingFamilyTabNode {
  /** Stable key used by the Reporting page's shell route mirror. */
  readonly key: 'overview' | 'pinned'
  /** Translation key rendered in the horizontal sub-navigation. */
  readonly labelSource: string
  /** Exact navigable URL for the tab. */
  readonly path: string
  /** AppLocation used by global breadcrumbs and sidenav state. */
  readonly appLocation: AppLocation
}

/** Exact, ordered Reporting family paths consumed by the flat registry. */
const overviewPath = reportingUrl()
const pinnedPath = reportingPinnedUrl()

export const reportingFamilyPaths = [pinnedPath, overviewPath] as const

/**
 * Reporting's durable page paths. Creation opens directly from Reporting's
 * flyout query param; private draft URLs are overlay redirects. Neither mounts
 * a separate page here.
 */
export const reportingRouteTree = {
  family: {
    rootPath: overviewPath,
    rootAppLocation: AppLocation.ReportingOverview,
    tabs: [
      {
        key: 'overview',
        labelSource: 'Overview',
        path: overviewPath,
        appLocation: AppLocation.ReportingOverview,
      },
      {
        key: 'pinned',
        labelSource: 'Pinned',
        path: pinnedPath,
        appLocation: AppLocation.ReportingPinned,
      },
    ] as const satisfies readonly ReportingFamilyTabNode[],
  },
  routes: [
    {
      key: 'pinned',
      path: pinnedPath,
      appLocation: AppLocation.ReportingPinned,
    },
    {
      key: 'root',
      path: overviewPath,
      appLocation: AppLocation.ReportingOverview,
    },
  ] as const satisfies readonly ReportingRouteNode[],
}

/** Every concrete Reporting route, in the frozen page-switch order. */
export const reportingRouteNodes = reportingRouteTree.routes
